import React, { useState } from "react";
import { Chip, Tooltip, TextField, Box } from "@mui/material";
import { User, Shield, X } from "react-feather";
import { HubIcon } from "../HubIcon";

/**
 * Visual indicator showing the current scanned employee status.
 * Displays who is scanned in and provides ability to clear the session.
 */
export const EmployeeScanIndicator = ({ 
  scannedEmployee, 
  isScanned, 
  onClear,
  onEmployeeScan,
  shouldShow = true, // Hide for users who already have edit permissions
}) => {
  const [employeeId, setEmployeeId] = useState("");

  const handleScan = (e) => {
    // Handle both Enter and Tab keys for different barcode scanners
    if ((e.key === 'Enter' || e.key === 'Tab') && employeeId.trim()) {
      e.preventDefault(); // Prevent tab from moving focus
      onEmployeeScan?.(employeeId.trim());
      setEmployeeId("");
    }
  };

  if (!shouldShow) {
    return null;
  }

  if (!isScanned) {
    return (
      <Tooltip title="Enter your employee ID to edit labor tickets">
        <TextField
          size="small"
          placeholder="Employee ID"
          value={employeeId}
          onChange={(e) => setEmployeeId(e.target.value.toUpperCase())}
          onKeyDown={handleScan}
          autoFocus
          InputProps={{
            startAdornment: <HubIcon icon="Barcode" size={14} style={{ marginRight: 10, marginLeft: -4, opacity: 0.6 }} />,
          }}
          sx={{
            width: 160,
            "& .MuiInputBase-root": {
              height: 28,
              fontSize: 11,
            },
            "& input": {
              padding: "6px 8px",
            },
          }}
        />
      </Tooltip>
    );
  }

  const Icon = scannedEmployee.isSupervisor ? Shield : User;
  const flow = scannedEmployee.isSupervisor ? "main" : "blue";

  return (
    <Chip
      icon={<Icon size={12} />}
      label={`${scannedEmployee.name}${scannedEmployee.isSupervisor ? " (Supervisor)" : ""}`}
      deleteIcon={
        <Tooltip title="Clear scan session">
          <X size={12} />
        </Tooltip>
      }
      onDelete={onClear}
      variant="colorTag"
      flow={flow}
      size="small"
      sx={{ 
        fontSize: 10,
        "& .MuiChip-icon": {
          marginLeft: "5px",
        },
        "& .MuiChip-deleteIcon": {
          fontSize: 14,
          marginRight: "5px",
          "&:hover": {
            opacity: 0.7,
          },
        },
      }}
    />
  );
};

export default EmployeeScanIndicator;
